export default (percentage: number) => {
    const percent = percentage * 100;

    if (percent === 0) {
        return '0%';
    } else if (percent < 0.1) {
        return '< 0.1%';
    } else if (percent === 100) {
        return '100%';
    }
    return percent.toFixed(1) + '%';
};
